import * as React from 'react';


export default class Pdf extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
      <svg className={this.props.className} xmlnsXlink="http://www.w3.org/1999/xlink">
        <polygon id="Fill-1" fill="#ECECEC" points="2.87814194 -0.000309677419 2.87814194 31.3720774 26.7934968 31.3720774 26.7934968 6.2304 20.3439484 -0.000309677419"></polygon>
        <polygon id="Fill-2" fill="#D2D2D2" points="20.3439484 -0.000309677419 20.3439484 6.2304 26.7934968 6.2304"></polygon>
        <polygon id="Fill-3" fill="#DC5757" points="0 19.1905032 28.3819355 19.1905032 28.3819355 8.54585806 0 8.54585806"></polygon>
        <polygon id="Fill-4" fill="#B53939" points="0 19.1907097 2.87793548 22.2234839 2.87793548 19.1907097"></polygon>
        <text id="PDF" fontFamily="Roboto-Medium, Roboto" fontSize="10" fontWeight="400" fill="#FEFEFE">
            <tspan x="5.41636129" y="17.3786888">PDF</tspan>
        </text>
        <path d="M20.4927464,27.9863742 C19.6589964,27.9863742 18.982675,27.3133419 18.982675,26.4813419 C18.982675,25.6493419 19.6589964,24.9763097 20.4927464,24.9763097 C21.3275321,24.9763097 22.0038536,25.6493419 22.0038536,26.4813419 C22.0038536,27.3133419 21.3275321,27.9863742 20.4927464,27.9863742 M15.4498536,26.653729 C20.541425,31.9863742 25.3751036,26.653729 25.3751036,26.653729 C20.0732821,21.1910194 15.4498536,26.653729 15.4498536,26.653729" id="Fill-5" fill="#CBCBCB"></path>
      </svg>
    )
  }
}
